import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import { Link } from 'react-router-dom';
import Spinner from 'components/Spinner/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cloudImageCrop } from 'utils/helpers';
import { handleLogout } from 'redux/modules/authentication';
import { ROUTE_PATHS } from 'config/constants';
import REP_DOT_IMAGE from 'assets/rep_dot.svg';
import './app-nav-menu.css';

const ICON_COMMUNITY = require('assets/icons/community-dg.svg');
const ICON_CAMPAIGN = require('assets/icons/megaphone-dg.svg');

class AppNavMenu extends PureComponent {
    static propTypes = {
        isAdmin: PropTypes.bool.isRequired,
        isRep: PropTypes.bool.isRequired,
        isVisible: PropTypes.bool.isRequired,
        logout: PropTypes.func.isRequired,
        hashid: PropTypes.string.isRequired,
        unreadNotifications: PropTypes.number.isRequired,
        avatar: PropTypes.string
    }

    state = {
        isLoggingOut: false
    }

    onLogout = () => {
        this.setState({
            isLoggingOut: true
        });

        this.props.logout();
    }

    render() {
        const { isAdmin, isRep, isVisible, hashid, avatar, unreadNotifications } = this.props;
        const { isLoggingOut } = this.state;

        if (!isVisible) {
            return null;
        }

        return (
            <div className='AppNavMenu'>
                <div>
                    <Link className='AppNavMenu__nav' to={ROUTE_PATHS.PROFILE(hashid)}>
                        {avatar
                            ? <img
                                className='AppNavMenu__nav-avatar'
                                src={avatar}
                                alt='avatar' />
                            : <FontAwesomeIcon
                                className='AppNavMenu__nav-avatar'
                                icon='user-circle' />
                        }

                        <div className='AppNavMenu__nav-label'>
                            Mon profil
                        </div>
                    </Link>

                    <Link className='AppNavMenu__nav' to={ROUTE_PATHS.MY_REPS}>
                        <img
                            className='AppNavMenu__nav-image'
                            src={REP_DOT_IMAGE}
                            alt='élus' />

                        <div className='AppNavMenu__nav-label'>
                            Mes élus
                        </div>
                    </Link>

                    <Link className='AppNavMenu__nav AppNavMenu__nav--mobile' to={ROUTE_PATHS.FACTIOS_MY}>
                        <img
                            className='AppNavMenu__nav-image'
                            src={ICON_COMMUNITY}
                            alt='Mes communautés' />

                        <div className='AppNavMenu__nav-label'>
                            Mes communautés
                        </div>
                    </Link>

                    <Link className='AppNavMenu__nav AppNavMenu__nav--mobile' to={ROUTE_PATHS.CAMPAIGNS_MY}>
                        <img
                            className='AppNavMenu__nav-image'
                            src={ICON_CAMPAIGN}
                            alt='Mes campagnes' />

                        <div className='AppNavMenu__nav-label'>
                            Mes campagnes
                        </div>
                    </Link>

                    {isRep && (
                        <Link className='AppNavMenu__nav' to={ROUTE_PATHS.NOTIFICATIONS}>
                            <img
                                className='AppNavMenu__nav-image'
                                src={require('assets/icons/bell-g.svg')}
                                alt='' />

                            <div className='AppNavMenu__nav-label'>
                                Notifications
                            </div>

                            {unreadNotifications
                                ? <div className='AppNavMenu__nav-counter'>
                                    {unreadNotifications}
                                </div>
                                : null
                            }
                        </Link>
                    )}

                    {isAdmin && (
                        <Link className='AppNavMenu__nav' to={ROUTE_PATHS.ADMIN}>
                            <FontAwesomeIcon
                                className='AppNavMenu__nav-image'
                                icon='lock' />

                            <div className='AppNavMenu__nav-label'>
                                Admin
                            </div>
                        </Link>
                    )}
                </div>

                <div className='AppNavMenu__hr' />

                <div>
                    <Link className='AppNavMenu__faq' to={ROUTE_PATHS.FAQ}>
                        FAQ
                    </Link>

                    <div className='AppNavMenu__logout' onClick={this.onLogout}>
                        {!isLoggingOut
                            ? <FontAwesomeIcon icon='sign-out-alt' />
                            : <Spinner size={20} />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ authentication, appnavmenu }) {
    const { profileData } = authentication;
    const avatar = profileData.avatar ? cloudImageCrop(profileData.avatar, 30) : null;

    return {
        isAdmin: authentication.isAdmin,
        isRep: authentication.isRep,
        isVisible: appnavmenu.isVisible,
        hashid: profileData.hashid,
        avatar: avatar,
        unreadNotifications: authentication.unreadNotifications
    };
}

function mapDispatchToProps(dispatch) {
    return {
        logout: () => {
            dispatch(handleLogout());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppNavMenu);
